import {B2BOrder} from '../hooks/type';
import {Run} from '@buncha/AboutShift/types';

export interface RescheduleListData {
  runs: [{[date: string]: Run[]}];
  order: B2BOrder;
  orderRun: Run;
}

// eslint-disable-next-line no-shadow
export enum RescheduleTimeSlots {
  morning = 'Morning',
  afternoon = 'Afternoon',
  evening = 'Evening',
}

export type RescheduleOptionSectionNode = {
  [section in RescheduleTimeSlots]: RescheduleOptionNode[];
};

export interface RescheduleOptionNode {
  id: number;
  title: string;
  subtitle?: string;
}

export interface RescheduleOrderParams {
  oldRunId: number;
  newRunId: number;
  orderIds: number[];
  note: string;
}

export interface CancelOrderParams {
  note: string;
}
